import { Table } from '@ifood/pomodoro-components';
import range from 'ramda/es/range';
import React from 'react';
import { LayoutProps, SpaceProps } from 'styled-system';

import { TablePlaceholderAnimation, TablePlaceholderStyle } from './styles';

export { TablePlaceholderAnimation, TablePlaceholderStyle };

type PropTypes = {
  rows?: number;
  columns?: number;
} & SpaceProps &
  LayoutProps &
  React.HTMLAttributes<HTMLDivElement>;

const TablePlaceholder = ({ rows = 3, columns = 2, ...props }: PropTypes): JSX.Element => (
  <TablePlaceholderStyle {...props}>
    <Table.Head>
      <Table.Row>
        {range(0, columns).map((key) => (
          <Table.Header key={key}>
            <TablePlaceholderAnimation />
          </Table.Header>
        ))}
      </Table.Row>
    </Table.Head>
    <Table.Body>
      {range(0, rows).map((row) => (
        <Table.Row key={row}>
          {range(0, columns).map((col) => (
            <Table.Data key={col}>
              <TablePlaceholderAnimation />
            </Table.Data>
          ))}
        </Table.Row>
      ))}
    </Table.Body>
  </TablePlaceholderStyle>
);

export default TablePlaceholder;
